import MultiSelectWithSearch from 'components/common/MiltiSelectSearch'
import { useEffect, useMemo, useState } from 'react'
import FilterMenu from '../../../common/FilterMenu'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import './agentFilters.scss'

interface AgentFiltersMenuProps {
  onClose?: () => void
  onApplyFilters: (filters: any) => void
  currentFilters: any
}

const STATUS_OPTIONS = [
  { value: 'Available', label: 'Available' },
  { value: 'Ringing', label: 'Ringing' },
  { value: 'In a queue call', label: 'In a queue call' },
  { value: 'Logged Out', label: 'Logged Out' },
  { value: 'DND', label: 'DND' },
]

export default function AgentFiltersMenu({ 
  onClose, 
  onApplyFilters, 
  currentFilters 
}: AgentFiltersMenuProps) {
  const [localFilters, setLocalFilters] = useState<any>({})

  useEffect(() => {
    setLocalFilters(currentFilters || {})
  }, [currentFilters])

  const handleFilterChange = (fieldName: string, value: any) => {
    setLocalFilters((prev: any) => ({ ...prev, [fieldName]: value }))
  }

  const handleApply = () => {
    onApplyFilters(localFilters)
    onClose?.()
  }

  const handleClear = () => {
    const cleared = Object.keys(localFilters || {}).reduce((acc: any, key: string) => {
      acc[key] = null
      return acc
    }, {})
    setLocalFilters(cleared)
  }

  return (
    <FilterMenu onClose={onClose} onApply={handleApply} onClear={handleClear}>
      <AgentFilterFields
        localFilters={localFilters}
        handleFilterChange={handleFilterChange}
      />
    </FilterMenu>
  )
}

interface AgentFilterFieldsProps {
  localFilters: any
  handleFilterChange: (fieldName: string, value: any) => void
}

export function AgentFilterFields({ 
  localFilters, 
  handleFilterChange 
}: AgentFilterFieldsProps) {
  const queues = useSelector((state: RootState) => state.apps.data.queue || [])
  const agents = useSelector((state: RootState) => state.agents.items)

  const queueOptions = useMemo(() => {
    return queues.map((queue: any) => ({ 
      label: queue.name || queue.extension, 
      value: queue.extension 
    }))
  }, [queues])

  const tierOptions = useMemo(() => {
    const tierSet = new Set<number>()
    agents.forEach((agent: any) => {
      if (agent.level && Array.isArray(agent.level)) {
        agent.level.forEach((tier: number) => tierSet.add(tier))
      }
    })
    return Array.from(tierSet).sort((a, b) => a - b).map(tier => ({
      label: `Tier ${tier}`,
      value: String(tier)
    }))
  }, [agents])

  return (
    <>
      <div className="filter-field">
        <div className="label">Status</div>
        <MultiSelectWithSearch
          className="call-center-multisearch"
          placeholder="Select Status"
          value={localFilters.status || []}
          onChange={(value) => handleFilterChange('status', value)}
          options={STATUS_OPTIONS}
        />
      </div>

      <div className="filter-field">
        <div className="label">Queue</div>
        <MultiSelectWithSearch
          className="call-center-multisearch"
          placeholder="Select Queue"
          value={localFilters.queue || []}
          onChange={(value) => handleFilterChange('queue', value)}
          options={queueOptions}
        />
      </div>

      <div className="filter-field">
        <div className="label">Tier</div>
        <MultiSelectWithSearch
          className="call-center-multisearch"
          placeholder="Select Tier"
          value={localFilters.tier || []}
          onChange={(value) => handleFilterChange('tier', value)}
          options={tierOptions}
        />
      </div>
    </>
  )
}

